export default "__VITE_ASSET__CwOAmhVS__"